var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainview"}},[_c('el-main',[_c('div',{attrs:{"id":"container"},on:{"keydown":function($event){return _vm.onKeyDown($event)},"keyup":function($event){return _vm.onKeyUp($event)}}})]),_c('Xiaoqu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }